// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__-skzN","signatureBlock":"Footer_signatureBlock__5kAqU","signature":"Footer_signature__1ziJQ"};